const blackBoletia = {
  25: '#FAFBFC',
  50: '#F4F5F7',
  100: '#E4E8E9',
  200: '#CCD2D5',
  300: '#A8B3B8',
  400: '#7D8B93',
  500: '#617079',
  600: '#535F67',
  700: '#485056',
  800: '#40464A',
  900: '#383C41',
  950: '#292D31',
  1000: '#0C0D0E',
};

export { blackBoletia };
